import { render, staticRenderFns } from "./PupilReport.vue?vue&type=template&id=4d0e3fd2&scoped=true"
import script from "./PupilReport.vue?vue&type=script&lang=js"
export * from "./PupilReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0e3fd2",
  null
  
)

export default component.exports